<template>
    <div class="navi">
        <router-link :to='getLinkTarget("HSTRequestAccept", "/philips/hst/HSTRequestAccept")'>
            <div :class='getClass("HSTRequestAccept")'><b-icon icon="stamper"/>受付</div>
        </router-link>
        <router-link :to='getLinkTarget("HSTDevicePreparation", "/philips/hst/HSTDevicePreparation")'>
            <div :class='getClass("HSTDevicePreparation")'><b-icon icon="barcode-scan"/>機器準備</div>
        </router-link>
        <router-link :to='getLinkTarget("HSTShippingList", "/philips/hst/HSTShippingList")'>
            <div :class='getClass("HSTShippingList")'><b-icon icon="truck-delivery-outline"/>機器出荷</div>
        </router-link>
        <router-link :to='getLinkTarget("HSTNumberOfShipmentSummary", "/philips/hst/HSTNumberOfShipmentSummary")'>
            <div :class='getClass("HSTNumberOfShipmentSummary")'><b-icon icon="file-excel"/>出荷実績シート</div>
        </router-link>
        <router-link :to='getLinkTarget("HSTDeviceReturn", "/philips/hst/HSTDeviceReturn")'>
            <div :class='getClass("HSTDeviceReturn")'><b-icon icon="receipt"/>機器受領</div>
        </router-link>
        <router-link :to='getLinkTarget("HSTAnalysisOrder", "/philips/hst/HSTAnalysisOrder")'>
            <div :class='getClass("HSTAnalysisOrder")'><b-icon icon="offer"/>解析依頼</div>
        </router-link>
        <router-link :to="{ name: 'HSTRequestSearch' }">
            <div :class='getClass("HSTRequestSearch")'><b-icon icon="text-search" />案件確認</div>
        </router-link>
        <router-link :to='getLinkTarget("HSTRequestContentChange", "/philips/hst/HSTRequestContentChange")'>
            <div :class='getClass("HSTRequestContentChange")'><b-icon icon="text-box-check"/>受付内容変更</div>
        </router-link>
    </div>
</template>

<script>
export default {
  name: "HSTNaviBar",
  props: ["pageid"],
  methods: {
      getLinkTarget: function(tabkind, target){
          var ret = target;
          if(tabkind == this.pageid){
              ret = ""
          }
          return ret;
      },
      getClass: function(tabkind) {
          var ret = "tabLabel ";
          if(tabkind == this.pageid){
            ret += "active";
          } else {
            ret += "deactive";
          }
          return ret;
      }

  },
  data() {
    return {
    };
  },
  filters: {},
  components: {},

};
</script>
<style lang="scss" scoped>
a {
  text-decoration: underline;
}
.navi {
    height: 20px;
    margin-top:-20px;
}
.tabLabel {
    float:left;
    text-align: center; 
    border-radius: 10px 10px 0px 0px;
    border-width:1px;
	border-top-style: solid;
	border-right-style: solid;
	border-left-style: solid;
    width: 146px;
    height: 30px;
}
.tabLabel.active {
    color: white;
	border-color: #000894;
    background-color: #000894;
}
.tabLabel.deactive {
	border-color: #f7f7f7;
    background-color: #e4e4e4;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/philips/hst/HSTNaviBar.vue